// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3vGOg","right":"styles_right__Oe2Xj"};